/* eslint-disable */
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/modal/Modal';
import { Button } from '../../shared/ui';
import { LoadingSm } from '../../components/loaders/localLoading/LocalLoading';
import styles from './RecoverBalanceModal.module.css';
import '../b2bPage/b2bPage.css';
import './historyPage.css';

export default function RecoverBalanceModal({ modalOpen, setModalOpen, onUpload, onManualRecover, isLoading, error }) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = e => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      onUpload(file);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
    setModalOpen(false);
  };

  return (
    <Modal setModalOpen={handleClose} modalOpen={modalOpen}>
      <div className={styles.container}>
        <div className={styles.textBlock}>
          <h2 className={styles.title}>{t('recoverBalanceAutomatically')}</h2>
          <p className={styles.hint}>{t('recoverBalanceUploadHint')}</p>
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className={styles.hiddenInput}
        />
        <div className={`historyButtonStack ${styles.actions}`}>
          <Button
            type="button"
            className="historyPageButton historyStationButton"
            onClick={() => fileInputRef.current?.click()}
            disabled={isLoading}
          >
            <span className="historyPageButtonLabel">
              {selectedFile ? selectedFile.name : t('recoverBalanceSelectFile')}
            </span>
          </Button>
          {error && (
            <>
              <p className={styles.error}>{t(`recoverBalanceError.${error}`)}</p>
              {onManualRecover && (
                <Button
                  type="button"
                  className="historyPageButton historyStationButton"
                  onClick={() => {
                    setModalOpen(false);
                    onManualRecover();
                  }}
                >
                  <span className="historyPageButtonLabel">{t('recoverBalanceManualFallback')}</span>
                </Button>
              )}
            </>
          )}
          <Button
            type="button"
            className="historyPageButton historyStationButton"
            onClick={handleClose}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="historyPageButtonLoading">
                <LoadingSm />
              </span>
            ) : (
              <span className="historyPageButtonLabel">{t('close')}</span>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
